<template>
  <div>
    <widget-web-component
      :company_id='$route.params.company_id'
    ></widget-web-component>
  </div>
</template>

<script>
export default {
  mounted(){
    let convodoWidget = document.createElement('script')
    convodoWidget.setAttribute('src', 'https://unpkg.com/convodo-widget-prototype@latest/dist/widget-web-component.min.js')
    document.head.appendChild(convodoWidget)
  }
}
</script>

<style lang="css" scoped>
</style>
